<template>
  <div class="p-2 p-x-4:d">
    <div v-if="services.length">
      <div class="text-large c-gray60 m-y-2">SERVICES</div>
      <div class="SUBTASKS">
        <div
            v-for="(service, index) in slicedServices"
            :key="index"
            class="c-black text-large m-b-2">
          {{ service.name }}
        </div>
      </div>
      <a
          v-if="services.length > $options.MIN_VISIBLE_SERVICES"
          class="link"
          @click="showingMore = !showingMore">
        <template v-if="showingMore">Show Less</template>
        <template v-else>Show More</template>
      </a>
    </div>
  </div>
</template>

<script>
const MIN_VISIBLE_SERVICES = 4;

export default {
  name: 'pro-services',
  MIN_VISIBLE_SERVICES,
  props: {
    services: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      showingMore: false,
    };
  },
  computed: {
    slicedServices () {
      return this.showingMore ? this.services : this.services.slice(0, MIN_VISIBLE_SERVICES);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .SUBTASKS {
    display: flex;
    flex-direction: column;

    @include tablet {
      display: block;
      column-count: 2;
    }

    @include desktop {
      column-count: 4;
    }
  }
</style>
